<template>
  <div>
    <transition name="fade" mode="out-in">
      <div
        v-if="!logged"
        class="home d-flex align-items-center w-100 position-relative"
      >
        <div
          v-if="!codeValidation"
          class="container-fluid text-md-left min-h-100"
          :style="navHeight"
        >
          <img
            src="@/assets/images/icons/p69-logo.svg"
            height="17"
            alt="Logo P69"
            class="ml-3 position-absolute logo-69"
          />
          <div class="row px-md-5 pb-4 justify-content-center mt-4">
            <div class="col-11 col-md-5 col-lg-4 col-xl-3 mr-md-auto">
              <h3 class="raleway-regular text-white mb-2 mt-0">
                MÁS VALE CALIDAD QUE CANTIDAD
              </h3>
            </div>
          </div>
          <div class="row px-md-5 pb-4 justify-content-center">
            <div class="col-12 col-md-5 col-lg-4 col-xl-3 mr-md-auto">
              <h4 class="raleway-light text-white mt-0 mb-3">
                Conoce los mejores clientes
                <br />de forma rápida y sencilla
              </h4>
            </div>
          </div>
          <div class="row px-md-5 justify-content-center">
            <div class="col-11 col-sm-10 col-md-5 col-lg-4 col-xl-3 mr-md-auto">
              <div class="phoneWrapper">
                <VuePhoneNumberInput
                  size="sm"
                  :only-countries="['CO', 'ES', 'PE', 'MX', 'AR']"
                  class="px-2"
                  default-country-code="CO"
                  v-model="username"
                  @update="updateCountrySelected"
                  :translations="{
                    countrySelectorLabel: 'País',
                    countrySelectorError: 'Escoge un país',
                    phoneNumberLabel: 'Teléfono movil',
                    example: 'Ejemplo: ',
                  }"
                />
              </div>
            </div>
          </div>
          <div class="row px-md-5 py-2 justify-content-center">
            <div class="col-11 col-sm-10 col-md-5 col-lg-4 col-xl-3 mr-md-auto">
              <div class="container-fluid px-0">
                <button class="bg-alert my-2" @click="logIn">Ingresar</button>
              </div>
            </div>
          </div>
        </div>

        <transition-expand>
          <div
            v-if="codeValidation"
            v-click-outside="swipeHandler"
            class="row position-fixed bg-white h-80 validation mx-auto overflow-auto"
          >
            <div
              v-touch:swipe.bottom="swipeHandler"
              class="col-12 py-4 d-md-none"
            >
              <img
                src="@/assets/images/icons/swipe-horizontal.svg"
                height="6"
                alt="Swipe down to close"
              />
            </div>
            <div class="col-12 pt-md-5 justify-self-start">
              <div class="col-12">
                <h1 class="my-0">Verificación</h1>
              </div>
            </div>
            <div class="col-12 py-4 justify-content-center">
              <div class="col-12 d-flex justify-content-center">
                <CodeInput
                  :loading="false"
                  class="input"
                  v-on:change="onChange"
                  v-on:complete="validateCode"
                  :fields="4"
                  v-model="pass"
                  auto-focus
                />
              </div>
              <div class="col-8 pt-4 mx-auto">
                <p class="subtext mt-0">
                  Ingresar el código de verificación que enviamos por sms a tu
                  teléfono móvil
                </p>
              </div>
            </div>
            <!-- <div class="row justify-content-center">
              
            </div>-->
            <!-- <div class="row">
          <button class="bg-alert" @click="validateCode">VALIDATE CODE</button>
            </div>-->
          </div>
        </transition-expand>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="logged" class="h-100 w-100" :style="navHeight">
        <transition name="fade" mode="out-in">
          <div
            v-if="logged && $route.path.length < 2"
            :class="
              'row min-h-100 w-100 flex-column justify-content-center mx-0 ' +
                (isActiveMenus !== false || activeAlert.status !== false
                  ? 'overflow-hidden'
                  : 'overflow-auto')
            "
            id="nav"
          >
            <div
              class="col-12 my-auto mx-auto pt-2 d-flex justify-content-center pb-5 pb-md-auto"
            >
              <div
                class="d-flex justify-content-start mt-2 mt-md-0 mb-5"
                style="flex-flow: row wrap; max-width: 288px;"
              >
                <router-link class="px-2 px-md-2 py-2" to="/profile">
                  <div
                    class="border h-100 p-3 section-home d-flex flex-column justify-content-center"
                  >
                    <img
                      src="@/assets/images/icons/profile.svg"
                      alt="Add new profile"
                      class="section-image pt-2"
                    />
                    <p class="mb-0">Perfil</p>
                  </div>
                </router-link>
                <router-link class="px-2 px-md-2 py-2" to="/photos">
                  <div
                    class="border h-100 p-3 section-home d-flex flex-column justify-content-center"
                  >
                    <img
                      src="@/assets/images/icons/photos.svg"
                      alt="Add new profile"
                      class="section-image pt-2"
                    />
                    <p class="mb-0">Fotos</p>
                  </div>
                </router-link>
                <!-- <router-link class="px-2 px-md-2 py-2" to="/videos">
                  <div
                    class="border h-100 p-3 section-home d-flex flex-column justify-content-center"
                  >
                    <img
                      src="@/assets/images/icons/videos.svg"
                      alt="Add new profile"
                      class="section-image pt-2"
                    />
                    <p class="mb-0">Videos</p>
                  </div>
                </router-link> -->
                <router-link class="px-2 px-md-2 py-2" to="/prices">
                  <div
                    class="border h-100 p-3 section-home d-flex flex-column justify-content-center"
                  >
                    <img
                      src="@/assets/images/icons/tarifas.svg"
                      alt="Add new profile"
                      class="section-image pt-2"
                    />
                    <p class="mb-0">Tarifas</p>
                  </div>
                </router-link>
                <router-link
                  v-if="kCity !== 'Online'"
                  class="px-2 px-md-2 py-2"
                  to="/places"
                >
                  <div
                    class="border h-100 p-3 section-home d-flex flex-column justify-content-center"
                  >
                    <img
                      src="@/assets/images/icons/places.svg"
                      alt="Add new profile"
                      class="section-image pt-2"
                    />
                    <p class="mb-0">Lugar</p>
                  </div>
                </router-link>
                <router-link class="px-2 px-md-2 py-2" to="/stats">
                  <div
                    class="border h-100 p-3 section-home d-flex flex-column justify-content-center"
                  >
                    <img
                      src="@/assets/images/icons/stats.svg"
                      alt="Add new profile"
                      class="section-image pt-2"
                    />
                    <p class="mb-0">Estadísticas</p>
                  </div>
                </router-link>
              </div>
            </div>

            <div
              v-if="kProfile != null"
              class="shadow-top container-fluid plan-bar d-flex justify-content-center align-items-center w-100 px-0 align-self-end mt-2 position-fixed bg-white"
            >
              <div class="justify-content-center row align-items-center w-100">
                <div class="col-4 pl-4 text-md-left mr-auto">
                  <h4 class="my-0 poppins-bold">
                    {{ !(kProfile.plan == undefined) ? daysLeft : 0 }} días
                  </h4>
                  <p class="my-0">Restantes</p>
                </div>
                <div class="col-xs-8 col-8 col-sm-5 col-md-3 col-xl-2 ml-auto">
                  <button
                    v-if="!kProfile.plan"
                    class="bg-accent"
                    @click="toggleVisibleProfile"
                  >
                    Plan Visibilidad
                  </button>
                  <button
                    v-if="kProfile.plan"
                    :class="
                      'bg-accent ' + (kProfile.plan.paused ? ' disabled' : '')
                    "
                    @click="togglePauseMenu()"
                  >
                    Pausar el Plan
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade" mode="out-in">
          <modal v-if="visibleProfile">
            <div v-click-outside="toggleVisibleProfile">
              <div class="row justify-content-center my-5">
                <div class="col-12 col-md-4 my-5">
                  <span class="text-white poppins-medium text-rem-1">
                    Tu perfil no está visible en el listado
                  </span>
                </div>
              </div>
              <div class="row justify-content-center mt-5">
                <div class="col-8 col-sm-7 col-md-4 col-xl-3">
                  <router-link
                    v-click-outside="visibleProfileToggle"
                    tag="button"
                    class="bg-accent"
                    to="/plans?steps=grid"
                  >
                    Activar Plan
                  </router-link>
                </div>
              </div>
              <div class="row justify-content-center mt-4">
                <div class="col-8 col-sm-7 col-md-4 col-xl-3">
                  <whatsapp-Button
                    v-click-outside="visibleProfileToggle"
                    :phone="company_data.client_service"
                    :text="
                      'Hola, necesito ayuda con la gestion de mis perfiles'
                    "
                    :buttonlabel="'Hablar con asesor'"
                    buttonClass="button outlined-white w-100 min-w-100"
                  />
                </div>
              </div>
            </div>
          </modal>
        </transition>
        <transition name="fade" mode="out-in">
          <modal v-if="isLoading">
            <loader scale="3" color="white" />
          </modal>
        </transition>
        <transition name="fade" mode="out-in">
          <router-view v-if="fetched && $route.path.length > 1" />
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside"
import settings from "@/api/settings"
import WhatsappButton from "@/components/UI/WhatsappButton.vue"
import moment from "moment"
import { mapGetters, mapActions } from "vuex"
import TransitionExpand from "@/components/Utils/TransitionExpand.vue"
import VuePhoneNumberInput from "vue-phone-number-input"
import "vue-phone-number-input/dist/vue-phone-number-input.css"
import CodeInput from "vue-verification-code-input"
import Modal from "@/components/UI/Partials/Modal.vue"
import Loader from "@/components/UI/Loader.vue"
export default {
  props: ["navHeight"],
  data() {
    return {
      company_data: settings.company_data,
      username: "",
      pass: "",
      reference: null,
      selected_country: null,
      codeValidation: false,
      visibleProfile: false,
    }
  },
  computed: {
    ...mapGetters([
      "countries",
      "user",
      "logged",
      "accountError",
      "navStyle",
      "colorScheme",
      "fetched",
      "isLoading",
      "activeAlert",
      "activeMenus",
      "kProfile",
      "kCity",
    ]),
    /* kProfile() {
      // renamed to make more sense
      if (this.user && this.user.profiles && this.user.kProfile) {
        return this.user.profiles.find(profile => {
          return profile._id == this.user.kProfile
        })
      } else return null
    }, */
    daysLeft() {
      if (this.kProfile && this.kProfile !== null) {
        const a = moment()
        const b = moment(this.kProfile.plan.to)
        return b.diff(a, "days") // 1
      } else {
        return 0
      }
    },
    isActiveMenus() {
      return Object.values(this.activeMenus).indexOf(true) >= 0
    },
  },
  methods: {
    ...mapActions([
      "requestCODE",
      "LOG_IN",
      "SET_NAVSTYLE",
      "SET_IS_LOADING",
      "SET_ACTIVE_MENUS",
    ]),
    updateCountrySelected(event) {
      const locombia = this.countries.find(c => {
        return c.iso2 == event.countryCode
      })
      this.selected_country = locombia
      console.log(locombia)
    },
    validateCode(v) {
      this.LOG_IN({
        username: `${this.selected_country.phone_code}${this.username.replace(
          /\s/g,
          ""
        )}`,
        pass: v,
      }).then(status => {
        if (status) {
          if (this.user.profiles.length == 0) {
            this.$router.push({
              path: "account",
              query: { welcome: true, step: 0 },
            })
          }
        }
      })
      this.swipeHandler()
      this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: this.colorScheme.accent,
        color: "white",
      })
    },
    async logIn() {
      const sms = this.$route.query.sms
      console.log(
        "before log in",
        this.username,
        this.pass,
        this.selected_country,
        this.reference,
        sms
      )
      let response = await this.requestCODE({
        phone: this.username.replace(/\s/g, ""),
        selected_country: this.selected_country,
        reference: this.reference,
        sms: sms,
      })
      console.log("RESPUESTA LOG", response)
      if (response == true) {
        this.codeValidation = true
      }
    },
    visibleProfileToggle() {
      console.log("visible profile toggle")
      if (!this.visibleProfile) {
        this.visibleProfile = true
      } else {
        this.visibleProfile = false
      }
    },
    swipeHandler() {
      this.codeValidation = false
    },
    onChange(v) {
      console.log("onChange ", v)
    },
    onComplete(v) {
      console.log("onComplete ", v)
    },
    toggleVisibleProfile() {
      /* document.getElementById("navbar").click()
      document.getElementById("navbar").focus() */

      setTimeout(
        function() {
          this.visibleProfile = true
        }.bind(this),
        10
      )
    },
    togglePauseMenu() {
      /* document.getElementById("navbar").click()
      document.getElementById("navbar").focus() */

      setTimeout(
        function() {
          console.log("toggle", this.activeMenus.isProfileMenu)
          this.SET_ACTIVE_MENUS({
            isPauseMenu: !this.activeMenus.isPauseMenu,
            isProfileSubMenu: false,
            isDeleteProfileMenu: false,
            isDeleteAccountMenu: false,
            isProfileMenu: false,
          }).then(status => {
            console.log("toggle", status, this.activeMenus.isProfileMenu)
          })
        }.bind(this),
        10
      )
    },
  },
  components: {
    TransitionExpand,
    VuePhoneNumberInput,
    CodeInput,
    Modal,
    WhatsappButton,
    Loader,
  },
  mounted() {
    if (this.user && this.user.profiles) {
      if (this.user.profiles.length == 0) {
        this.$router.push({
          path: "account",
          query: { welcome: true, step: 0 },
        })
      }
    }
    console.log("PROPS", this.navHeight, this.logged)
    if (this.logged) {
      window.scrollTo({ top: 0, behavior: "smooth" })
      this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: this.colorScheme.accent,
        color: "white",
        boxShadow: "none",
      })
    } else {
      this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: "transparent",
        color: "white",
        boxShadow: "none",
      })
    }
    if (this.$route.params.id) {
      this.reference = this.$route.params.id
      this.$router.push("/")
    }
  },
  watch: {
    //para actualizar componente en cambio de ruta
    async $route(to /*, from*/) {
      window.scrollTo({ top: 0, behavior: "smooth" })
      const routerParameter = to.params.param0
      if (routerParameter) {
        console.log("LLENDO A UNA SECCION")
        this.SET_NAVSTYLE({
          ...this.navStyle,
          backgroundColor: "white",
          color: this.colorScheme.dark,
          boxShadow: "0 3px 6px 0 rgba(0,0,0,0.15)",
        })
      } else {
        console.log("LLENDO AL MENU", this.logged)
        if (!this.logged == false) {
          this.SET_NAVSTYLE({
            ...this.navStyle,
            backgroundColor: this.colorScheme.accent,
            color: "white",
            boxShadow: "none",
          })
        } else {
          this.SET_NAVSTYLE({
            ...this.navStyle,
            backgroundColor: "transparent",
            color: "white",
            boxShadow: "none",
          })
        }
      }
    },
  },
  directives: {
    ClickOutside,
  },
}
</script>

<style lang="scss">
.logo-69 {
  top: 20px;
  left: 12px;
}
.home {
  min-height: 100%;
  background: linear-gradient(
      to bottom,
      rgba(67, 61, 122, 0.45),
      rgba(15, 11, 27, 0.8)
    ),
    url("../assets/images/photos/home.jpg");
  background-position: center top; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.input-tel__input,
.country-selector__input {
  border: none !important;
  background-color: transparent;
}
.input-tel__input {
  border-left: 2px solid #e0e0e0 !important;
  border-radius: 0;
}
.country-selector__label {
  display: none;
}
/* .country-selector__input {
  padding: 0.2rem 0.5rem !important;
} */
.vue-phone-number-input .select-country-container {
  -webkit-box-flex: 0 !important;
  -ms-flex: 0 0 100px !important;
  flex: 0 0 100px !important;
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
}
.country-selector__country-flag {
  position: absolute;
  top: calc(50% - 7px) !important;
  left: 8px;
}
.country-selector__toggle[data-v-46e105de] {
  top: calc(50% - 12px);
  height: 24px;
}
.phoneWrapper {
  border: 0 solid $alertColor;
  border-radius: 1.5em;
  padding: 0.2rem 0.5rem;
  background: rgb(255, 255, 255);
  border-collapse: collapse;
  &:focus-within {
    border: 2px solid $alertColor;
  }
}
.flag {
  height: 2em;
}

.react-code-input > input {
  font-family: "Poppins", sans-serif !important;
}

.plan-bar {
  height: 75px !important;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
<style lang="scss" scope>
.resize-observer {
  display: none;
}
.country-selector__list {
  height: fit-content !important;
  max-height: 100px !important;
}
</style>
